'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HotelItem = exports.mapDispatchToProps = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

exports.mapStateToProps = mapStateToProps;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reactRedux = require('react-redux');

var _url = require('url');

var _url2 = _interopRequireDefault(_url);

var _reactSlick = require('react-slick');

var _reactSlick2 = _interopRequireDefault(_reactSlick);

require('slick-carousel/slick/slick.css');

require('../components/Slick/SlickCustomize.css');

var _Price = require('../components/Price');

var _Price2 = _interopRequireDefault(_Price);

var _hotels = require('../modules/hotels');

var _trvFedUtil = require('../trv-fed-util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// mapStateToprops can be either an object or a funciton
// HotelItem

function mapStateToProps(state, ownProps) {
  return {
    i18n: state.i18n,
    location: ownProps.location,
    currencies: state.currencies
  };
}

var mapDispatchToProps = exports.mapDispatchToProps = {
  hoverHotel: _hotels.hover
};
// TODO: remove style once the design is finalized

var HotelItem = function (_Component) {
  (0, _inherits3.default)(HotelItem, _Component);

  function HotelItem() {
    (0, _classCallCheck3.default)(this, HotelItem);
    return (0, _possibleConstructorReturn3.default)(this, (HotelItem.__proto__ || (0, _getPrototypeOf2.default)(HotelItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(HotelItem, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          i18n = _props.i18n,
          item = _props.item,
          style = _props.style,
          display = _props.display,
          hoverHotel = _props.hoverHotel,
          location = _props.location,
          currencies = _props.currencies;

      var currency = currencies.find(function (currency) {
        return currency.id === item.currency;
      }) || {};

      var settings = {
        centerMode: true,
        centerPadding: '0px',
        infinite: true,
        lazyLoad: true,
        arrows: true,
        speed: 200,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: _react2.default.createElement(
          'button',
          { 'aria-label': 'Switch to previous photo' },
          _react2.default.createElement('span', { className: 'icon-thin-prev' })
        ),
        nextArrow: _react2.default.createElement(
          'button',
          { 'aria-label': 'Switch to next photo' },
          _react2.default.createElement('span', { className: 'icon-thin-next' })
        )
      };

      return _react2.default.createElement(
        'div',
        {
          className: 'hotel-item',
          style: style || {},
          onMouseEnter: function onMouseEnter() {
            return hoverHotel(item.id);
          },
          onMouseLeave: function onMouseLeave() {
            return hoverHotel();
          }
        },
        _react2.default.createElement(
          _reactRouter.Link,
          { to: (0, _extends3.default)({}, location, { pathname: _url2.default.parse(item.pageUrl).pathname }), target: '_blank', rel: 'noopener noreferrer' },
          _react2.default.createElement(
            'div',
            { className: 'hotel-item-sub' },
            _react2.default.createElement(
              'div',
              {
                className: 'hotel-item-upper',
                ref: function ref(elem) {
                  _this2.container = elem;
                }
              },
              _react2.default.createElement(
                'div',
                { className: 'hotel-image-box' },
                display !== 'carousel' || item.media && item.media.length < 2 ? _react2.default.createElement('div', {
                  className: 'hotel-image-box-sub',
                  style: {
                    width: '100%',
                    backgroundImage: item.media[0] ? 'url(' + (0, _trvFedUtil.concateQueryParamsToImageUrl)(item.media[0].thumbnailUrl, 500) + ')' : 'none'
                  }
                }) : _react2.default.createElement(
                  _reactSlick2.default,
                  settings,
                  item.media.map(function (item, index) {
                    return _react2.default.createElement(
                      'div',
                      { key: index },
                      _react2.default.createElement('div', {
                        style: {
                          width: '100%',
                          height: '100%',
                          backgroundImage: 'url(' + (0, _trvFedUtil.concateQueryParamsToImageUrl)(item.mediaUrl, 500) + ')',
                          backgroundSize: 'cover',
                          backgroundPosition: 'center'
                        }
                      })
                    );
                  })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'guest-rating-box' },
                _react2.default.createElement(
                  'span',
                  null,
                  i18n.top.guestRating
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'rating-score' },
                  item.review !== '0' ? item.review : '-'
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  '\xA0/\xA05'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'hotel-price-box' },
                item.roomLeft ? _react2.default.createElement(
                  'div',
                  { className: 'left-rooms' },

                  /* XXX: a cumbersome way to deal with i18n plurals */
                  i18n.hotelSearch.roomLeft.replace(/{number}/g, item.roomLeft).replace(/{room}/g, +item.roomLeft > 1 ? i18n.hotelSearch.rooms : i18n.hotelSearch.room)
                ) : null,
                item.price !== undefined ? _react2.default.createElement(
                  'div',
                  { className: 'price-and-point' },
                  _react2.default.createElement(_Price2.default, { i18n: i18n, item: item, currency: currency }),
                  item.lead ? _react2.default.createElement(
                    'div',
                    { className: 'about-price' },
                    item.lead
                  ) : null,
                  item.point ? i18n.hotelSearch.earn.split(/({.*})/).map(function (text, index) {
                    switch (true) {
                      case /{.*}/.test(text):
                        return (
                          // eslint-disable-next-line react/no-array-index-key
                          _react2.default.createElement(
                            'div',
                            { key: index, className: 'get-point' },
                            _react2.default.createElement(
                              'span',
                              { className: 'get-point-detail' },
                              Number(item.point).toLocaleString(i18n.lang.replace('_', '-'))
                            ),
                            _react2.default.createElement(
                              'span',
                              { className: 'point-title' },
                              Number(item.point.replace(/[^0-9.]+/g, '')) > 1 ? i18n.hotelInformation.Points : i18n.hotelInformation.Point
                            )
                          )
                        );
                      default:
                        // eslint-disable-next-line react/no-array-index-key
                        return text.trim() ? _react2.default.createElement(
                          'div',
                          { key: index, className: 'point-info' },
                          text.trim(),
                          Number(item.pointRatio) > 1 ? _react2.default.createElement(
                            'span',
                            null,
                            _react2.default.createElement(
                              'span',
                              { className: 'point10x' },
                              item.pointRatio,
                              'x'
                            ),
                            _react2.default.createElement(
                              'span',
                              { className: 'point-title' },
                              Number(item.point.replace(/[^0-9.]+/g, '')) > 1 ? i18n.hotelInformation.Points : i18n.hotelInformation.Point,
                              '!'
                            )
                          ) : null
                        ) : null;
                    }
                  }) : null
                ) : null
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'hotel-item-bottom' },
              _react2.default.createElement(
                'div',
                { className: 'hotel-name' },
                item.name
              ),
              _react2.default.createElement(
                'div',
                { className: 'hotel-rate-stars' },
                _react2.default.createElement(
                  'span',
                  { className: 'for-reader' },
                  i18n.top.forReader.replace(/{rate}/g, (+item.rate).toPrecision(2))
                ),
                _react2.default.createElement('span', { className: 'hotel-rate hotel-rate' + item.rate })
              )
            )
          )
        )
      );
    }
  }]);
  return HotelItem;
}(_react.Component);

HotelItem.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  item: _react.PropTypes.object.isRequired,
  style: _react.PropTypes.object,
  display: _react.PropTypes.string,
  hoverHotel: _react.PropTypes.func.isRequired,
  location: _react.PropTypes.object.isRequired,
  currencies: _react.PropTypes.array.isRequired
};

HotelItem.defaultProps = {
  display: 'carousel'
};

exports.HotelItem = HotelItem;
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(HotelItem);


//////////////////
// WEBPACK FOOTER
// ./src/containers/HotelItem.js
// module id = 582
// module chunks = 0